import * as React from 'react'

import { Box, SearchField, Skeleton } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import EmployeeMultiFilters from 'modules/core/components/EmployeeMultiFilters'
import { filterFields } from 'modules/core/components/EmployeeMultiFilters/commonFilters'
import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import { useEmployeeGroups } from 'modules/core/components/MultiFilters/hooks/useEmployeeGroups'
import type { FilterOption as MultiFilterOption } from 'modules/core/components/MultiFilters/types'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

interface Props {
  filtersForm: FiltersForm
  search: string
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: (defaultFilter?: MultiFilterForm[]) => void
  onCancel: () => void
}

const SearchBar = ({
  filters,
  onSearch,
  search,
  logicOperator,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
}: Props) => {
  const { employeeGroups } = useEmployeeGroups()

  const [fields, setFields] = React.useState<readonly MultiFilterOption[]>([])
  const { loading } = useAsyncData(async () => {
    const fields = await filterFields(employeeGroups)

    setFields(fields)
  }, [])

  return (
    <>
      <Box flexNoShrink>
        {loading && <Skeleton width="s140" height="s40" />}
        {!loading && (
          <EmployeeMultiFilters
            label={i18n.t('filters.multi_filters.title')}
            fields={fields}
            filters={filters}
            logicOperator={logicOperator}
            onAddFilter={onAddFilter}
            onRemoveFilter={onRemoveFilter}
            onApplyFilters={onApplyFilters}
            onCancel={onCancel}
            showDefaultFilters
          />
        )}
      </Box>
      <Box width="full">
        <SearchField
          variant="big"
          onSearch={onSearch}
          search={search}
          placeholder={i18n.t('common.search')}
        />
      </Box>
    </>
  )
}

export default observer(SearchBar)
